import {Long} from "protobufjs";

export const shortTimeFormat = (date: Date) => {
  return date.toLocaleTimeString(undefined, {timeStyle: 'short'});
}

export const shortDateFormat = (date: Date) => {
  return date.toLocaleDateString(undefined, {dateStyle: 'short'});
}

export const longDateFormat = (date: Date) => {
  return date.toLocaleDateString(undefined, {dateStyle: 'full'});
}

export const shortDateTimeFormat = (date: Date) => {
  if (date.getTime() == 0) {
    return '';
  }

  return date.toLocaleString(undefined, {dateStyle: 'medium', timeStyle: 'short'});
}

export const shortDateFormat2 = (timestamp: number | Long | null | undefined) => {
  if (!timestamp) {
    return "Unknown";
  }
  return shortDateFormat(new Date(timestamp as number));
}


export const shortDateTimeFormat2 = (timestamp: number | Long | null | undefined) => {
  if (!timestamp) {
    return "Unknown";
  }

  return shortDateTimeFormat(new Date(timestamp as number));
}
